export function Thumbnail({image}: any) {
    return (
        <div className="bg-black h-[84px] w-[153px] flex justify-center rounded-sm">
            <img
                src={URL.createObjectURL(image)}
                alt="Image Preview"
                className="h-full w-auto rounded-lg"
            />
        </div>
    );
}

export function LargeThumbnail({image}: any) {
    return (
        <div className="bg-black h-40 w-[300px] flex justify-center rounded-sm">
            <img
                src={image}
                alt="Image Preview"
                className="h-full w-auto rounded-lg"
            />
        </div>
    );
}